import { useEffect } from "react";

import {
	CHECK_INTERVAL_MS,
	checkServedBuild,
	getOwnBuildId,
	useNewBuildFound,
} from "./newBuild";

/**
 * Checks once a minute, when the tab comes back into view and when the
 * network returns; stops after the new build is found. Without a build id
 * (`npm start`) there is nothing to compare, so no checks.
 */
const useNewBuildCheck = () => {
	const found = useNewBuildFound();

	useEffect(() => {
		const ownBuildId = getOwnBuildId();
		if (found || !ownBuildId) return undefined;

		const check = () => {
			checkServedBuild(ownBuildId);
		};
		const onVisibility = () => {
			if (document.visibilityState === "visible") check();
		};

		const timer = window.setInterval(check, CHECK_INTERVAL_MS);
		document.addEventListener("visibilitychange", onVisibility);
		window.addEventListener("online", check);
		return () => {
			window.clearInterval(timer);
			document.removeEventListener("visibilitychange", onVisibility);
			window.removeEventListener("online", check);
		};
	}, [found]);

	return found;
};

export default useNewBuildCheck;
